<template>
    <div class="col-12">
        <div>
            <div class="row">
                <div class="col-md-6 col-12 p-0 mb-2">
                    <div class="h4">{{ $lang('Role systemowe') }}</div>
                </div>
                <div class="form-group col-md-6 col-12 text-right p-0">
                    <button type="button" class="btn btn-default col-md-auto col-12"
                            @click="addSystemRole">{{ $lang('Nowa rola') }}
                    </button>
                </div>
            </div>
            <div class="row" v-if="systemRoles.length > 0">
                <table class="table simple-table table-striped table-sm">
                    <thead>
                    <tr>
                        <th scope="col">{{ $lang('Rola') }}</th>
                        <th scope="col">{{ $lang('Klient') }}</th>
                        <th scope="col">{{ $lang('Aktywna') }}</th>
                        <th scope="col">{{ $lang('Panel administracyjny') }}</th>
                        <th scope="col">{{ $lang('Akcje') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="role in systemRoles">
                        <td :data-title="$lang('Rola')">{{ role.name }}</td>
                        <td :data-title="$lang('Klient')">
                            <span class="badge"
                                  :class="{'badge-success': role.is_customer, 'badge-danger': !role.is_customer}">
                                {{ role.is_customer ? 'TAK' : 'NIE' }}
                            </span>
                        </td>
                        <td :data-title="$lang('Aktywna')">
                            <span class="badge"
                                  :class="{'badge-success': role.active, 'badge-danger': !role.active}">
                                {{ role.active ? 'TAK' : 'NIE' }}
                            </span>
                        </td>
                        <td :data-title="$lang('Panel administracyjny')">
                            <span v-if="role.is_customer">
                                {{ $lang('nd.') }}
                            </span>
                            <span v-else class="badge"
                                  :class="{'badge-success': role.is_admin, 'badge-danger': !role.is_admin}">
                                {{ role.is_admin ? 'TAK' : 'NIE' }}
                            </span>
                        </td>
                        <td :data-title="$lang('Akcje')">
                            <a class="mr-3" @click.prevent="editSystemRole(role)" href="#">{{ $lang('Edytuj') }}</a>
                            <a class="mr-3" @click.prevent="removeSystemRole(role.id)" href="#">{{ $lang('Usuń') }}</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="mt-4" v-if="app_mode === 'ORACLE'">
            <div class="row">
                <div class="col-md-6 col-12 p-0 mb-2">
                    <div class="h4">{{ $lang('Role projektowe') }}</div>
                </div>
                <div class="form-group col-md-6 col-12 text-right p-0">
                    <button type="button" class="btn btn-default col-md-auto col-12"
                            @click="addProjectRole">{{ $lang('Nowa rola') }}
                    </button>
                </div>
            </div>
            <div class="row" v-if="projectRoles.length > 0">
                <table class="table simple-table table-striped table-sm">
                    <thead>
                    <tr>
                        <th scope="col">{{ $lang('Rola') }}</th>
                        <th scope="col">{{ $lang('Klient') }}</th>
                        <th class="text-center" scope="col" colspan="2">{{ $lang('Widoczność') }}</th>
                        <th class="text-center" scope="col" colspan="2">{{ $lang('Edycja') }}</th>
                        <th scope="col">{{ $lang('Dodawanie') }}</th>
                        <th scope="col">{{ $lang('Akcje') }}</th>
                    </tr>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col">{{ $lang('własne') }}</th>
                        <th scope="col">{{ $lang('obce') }}</th>
                        <th scope="col">{{ $lang('własne') }}</th>
                        <th scope="col">{{ $lang('obce') }}</th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="role in projectRoles">
                        <td :data-title="$lang('Rola')">{{ role.name }}</td>
                        <td :data-title="$lang('Klient')">
                            <span class="badge"
                                  :class="{'badge-success': role.is_customer, 'badge-danger': !role.is_customer}">
                                {{ role.is_customer ? 'TAK' : 'NIE' }}
                            </span>
                        </td>
                        <td :data-title="$lang('Przeglądanie własnych zgłoszeń')">
                            <span class="badge" :class="{'badge-success': role.show_owner_access, 'badge-danger': !role.show_owner_access}">
                                {{ role.show_owner_access ? 'TAK' : 'NIE' }}
                            </span>
                        </td>
                        <td :data-title="$lang('Przeglądanie obcych zgłoszeń')">
                            <span class="badge" :class="{'badge-success': role.show_other_access, 'badge-danger': !role.show_other_access}">
                                {{ role.show_other_access ? 'TAK' : 'NIE' }}
                            </span>
                        </td>
                        <td :data-title="$lang('Edycja własnych zgłoszeń')">
                            <span class="badge" :class="{'badge-success': role.edit_owner_access, 'badge-danger': !role.edit_owner_access}">
                                {{ role.edit_owner_access ? 'TAK' : 'NIE' }}
                            </span>
                        </td>
                        <td :data-title="$lang('Edycja obcych zgłoszeń')">
                            <span class="badge" :class="{'badge-success': role.edit_other_access, 'badge-danger': !role.edit_other_access}">
                                {{ role.edit_other_access ? 'TAK' : 'NIE' }}
                            </span>
                        </td>
                        <td :data-title="$lang('Dodawanie zgłoszeń')">
                            <span class="badge" :class="{'badge-success': role.add_access, 'badge-danger': !role.add_access}">
                                {{ role.add_access ? 'TAK' : 'NIE' }}
                            </span>
                        </td>
                        <td :data-title="$lang('Akcje')">
                            <a class="mr-3" @click.prevent="editProjectRole(role)" href="#">{{ $lang('Edytuj') }}</a>
                            <a class="mr-3" @click.prevent="removeProjectRole(role.id)" href="#">{{ $lang('Usuń') }}</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
<!--            <div class="row" v-if="projectRoles.length > 0">-->
<!--                <div class="col-12 small">-->
<!--                    <p class="mb-1"><sup>1)</sup>{{ $lang('możliwość przeglądania zgłoszeń, do których dana osoba nie jest przypisana') }}</p>-->
<!--                    <p class="mb-1"><sup>2)</sup>{{ $lang('możliwość dodawania zgłoszeń') }}</p>-->
<!--                </div>-->
<!--            </div>-->
        </div>

        <div class="modal fade" id="modal_dict_sys_role" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalMode === 'new' ? $lang('Nowa rola') : $lang('Edycja roli') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <input class="form-control" id="new_sys_mrole" placeholder="Nazwa"
                                   v-model="systemRoleEditable.name">
                            <small class="text-red" v-if="error === true">
                                {{ errorMessage }}</small>
                        </div>
                        <div class="row px-1">
                            <div class="col-md-auto col-12 form-group mb-0">
                                <input type="checkbox" id="new_sys_role_is_customer" v-model="systemRoleEditable.is_customer">
                                <label for="new_sys_role_is_customer">{{ $lang('klient') }}</label>
                            </div>
                            <div class="col-md-auto col-12 form-group mb-0">
                                <input type="checkbox" id="new_sys_role_active" v-model="systemRoleEditable.active">
                                <label for="new_sys_role_active">{{ $lang('aktywna') }}</label>
                            </div>
                            <div class="col-md-auto col-12 form-group mb-0" v-if="!systemRoleEditable.is_customer">
                                <input type="checkbox" id="new_sys_role_is_admin" v-model="systemRoleEditable.is_admin">
                                <label for="new_sys_role_is_admin">{{ $lang('panel administracyjny') }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">{{
                                $lang('Zamknij')
                            }}
                        </button>
                        <button id="sys-role-new" v-if="modalMode === 'new'" @click.prevent="createSystemRole()" type="button" class="btn btn-primary" :disabled="!newSystemRoleValid">
                            {{ $lang('Utwórz') }}
                        </button>
                        <button id="sys-role-edit" v-else @click.prevent="updateSystemRole()" type="button" class="btn btn-primary" :disabled="!newSystemRoleValid">
                            {{ $lang('Zapisz') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modal_dict_proj_role" tabindex="-1" v-if="app_mode === 'ORACLE'">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalMode === 'new' ? $lang('Nowa rola') : $lang('Edycja roli') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row px-1">
                            <div class="col-md-auto col-12 form-group mb-0">
                                <input type="checkbox" id="new_proj_role_is_customer" v-model="projectRoleEditable.is_customer">
                                <label for="new_proj_role_is_customer">{{ $lang('Rola przeznaczona dla klienta') }}</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <input class="form-control" id="new_proj_mrole" placeholder="Nazwa"
                                   v-model="projectRoleEditable.name">
                            <small class="text-red" v-if="error === true">
                                {{ errorMessage }}</small>
                        </div>
                        <div class="row px-1">
                            <div class="col-md-auto col-12 form-group mb-0">
                                <input type="checkbox" id="new_proj_role_show_owner_access" v-model="projectRoleEditable.show_owner_access">
                                <label for="new_proj_role_show_owner_access">{{ $lang('Przeglądanie własnych zgłoszeń') }}</label>
                            </div>
                        </div>
                        <div class="row px-1">
                            <div class="col-md-auto col-12 form-group mb-0">
                                <input type="checkbox" id="new_proj_role_show_other_access" v-model="projectRoleEditable.show_other_access">
                                <label for="new_proj_role_show_other_access">{{ $lang('Przeglądanie obcych zgłoszeń') }}</label>
                            </div>
                        </div>
                        <div class="row px-1">
                            <div class="col-md-auto col-12 form-group mb-0">
                                <input type="checkbox" id="new_proj_role_edit_owner_access" v-model="projectRoleEditable.edit_owner_access">
                                <label for="new_proj_role_edit_owner_access">{{ $lang('Edycja własnych zgłoszeń') }}</label>
                            </div>
                        </div>
                        <div class="row px-1">
                            <div class="col-md-auto col-12 form-group mb-0">
                                <input type="checkbox" id="new_proj_role_edit_other_access" v-model="projectRoleEditable.edit_other_access">
                                <label for="new_proj_role_edit_other_access">{{ $lang('Edycja obcych zgłoszeń') }}</label>
                            </div>
                        </div>
                        <div class="row px-1">
                            <div class="col-md-auto col-12 form-group mb-0">
                                <input type="checkbox" id="new_proj_role_add_access" v-model="projectRoleEditable.add_access">
                                <label for="new_proj_role_add_access">{{ $lang('Dodawanie zgłoszeń') }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">{{
                                $lang('Zamknij')
                            }}
                        </button>
                        <button id="role-new" v-if="modalMode === 'new'" @click.prevent="createProjectRole()" type="button" class="btn btn-primary" :disabled="!newProjectRoleValid">
                            {{ $lang('Utwórz') }}
                        </button>
                        <button id="role-edit" v-else @click.prevent="updateProjectRole()" type="button" class="btn btn-primary" :disabled="!newProjectRoleValid">
                            {{ $lang('Zapisz') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ShowNotification from "../../mixins/show-notification";

export default {
    name: "dictionary-role",
    mixins: [ShowNotification],
    props: {
        get_route: String,
        update_system_role_route: String,
        store_system_role_route: String,
        delete_system_role_route: String,
        update_project_role_route: String,
        store_project_role_route: String,
        delete_project_role_route: String,
        app_mode: String,
    },
    data() {
        return {
            systemRoles: [],
            projectRoles: [],
            error: false,
            errorMessage: '',
            systemRoleEditable: {
                id: null,
                name: '',
                active: false,
                is_admin: false,
                is_customer: false,
            },
            projectRoleEditable: {
                id: null,
                name: '',
                is_customer: false,
                show_owner_access: false,
                show_other_access: false,
                edit_owner_access: false,
                edit_other_access: false,
                show_other_default: false,
                add_access: false,
            },
            modalMode: 'add'
        }
    },
    methods: {
        getRoles() {
            let self = this;
            axios.get(this.get_route, {})
                 .then(function (response) {
                     self.systemRoles = response.data.system_roles;
                     self.projectRoles = response.data.project_roles;
                 })
                 .catch((error) => {
                 });
        },
        createSystemRole() {
            let self = this;
            axios.post(this.store_system_role_route, this.systemRoleEditable)
                 .then(function (response) {
                     self.systemRoles = response.data;
                     $('#modal_dict_sys_role').modal('hide');
                 })
                 .catch((error) => {
                     if (error.response.status === 422) {
                         self.error = true;
                         self.errorMessage = error.response.data;
                     }
                 });
        },
        updateSystemRole() {
            let self = this;
            axios.patch(this.update_system_role_route, this.systemRoleEditable)
                 .then(function (response) {
                     self.systemRoles = response.data;
                     $('#modal_dict_sys_role').modal('hide');
                 })
                 .catch((error) => {
                     console.log(error);
                     if (error.response.status === 422) {
                         self.error = true;
                         self.errorMessage = error.response.data;
                     }
                 });
        },
        removeSystemRole(id) {
            let self = this;
            axios.post(this.delete_system_role_route, {id: id})
                 .then(function (response) {
                     self.systemRoles = response.data;
                 })
                 .catch((error) => {
                     if (error.response.status === 422) {
                         this.showNotification('error', error.response.data.errors);
                     } else if (error.response.status === 400) {
                         this.showNotification('error', 'Nie można usunąć roli, ponieważ istnieje przypisanie do co najmniej jednej osoby.');
                     } else{
                         console.log(error);
                     }
                 });
        },
        createProjectRole() {
            let self = this;
            axios.post(this.store_project_role_route, this.projectRoleEditable)
                .then(function (response) {
                    self.projectRoles = response.data;
                    $('#modal_dict_proj_role').modal('hide');
                })
                .catch((error) => {
                    if (error.response.status === 422) {
                        self.error = true;
                        self.errorMessage = error.response.data;
                    }
                });
        },
        updateProjectRole() {
            let self = this;
            axios.patch(this.update_project_role_route, this.projectRoleEditable)
                .then(function (response) {
                    self.projectRoles = response.data;
                    $('#modal_dict_proj_role').modal('hide');
                })
                .catch((error) => {
                    console.log(error);
                    if (error.response.status === 422) {
                        self.error = true;
                        self.errorMessage = error.response.data;
                    }
                });
        },
        removeProjectRole(id) {
            let self = this;
            axios.post(this.delete_project_role_route, {id: id})
                .then(function (response) {
                    self.projectRoles = response.data;
                })
                .catch((error) => {
                    if (error.response.status === 422) {
                        this.showNotification('error', error.response.data.errors);
                    } else if (error.response.status === 400) {
                        this.showNotification('error', 'Nie można usunąć roli, ponieważ istnieje przypisanie do co najmniej jednej osoby.');
                    } else{
                        console.log(error);
                    }
                });
        },
        addSystemRole() {
            this.openSystemRoleModal('new', null, '', false, false, false);
        },
        editSystemRole(role) {
            this.openSystemRoleModal('edit', role.id, role.name, role.active, role.is_admin, role.is_customer);
        },
        addProjectRole() {
            this.openProjectRoleModal('new', null, '', false, false, false, false,false, false, false);
        },
        editProjectRole(role) {
            this.openProjectRoleModal('edit', role.id, role.name, role.is_customer, role.show_owner_access, role.show_other_access, role.edit_owner_access, role.edit_other_access, role.show_other_default, role.add_access);
        },
        openSystemRoleModal(mode, id, name, active, isAdmin, isCustomer) {
            this.modalMode = mode;
            this.error = false;
            this.errorMessage = '';
            this.systemRoleEditable.id = id;
            this.systemRoleEditable.name = name;
            this.systemRoleEditable.active = active;
            this.systemRoleEditable.is_admin = isAdmin;
            this.systemRoleEditable.is_customer = isCustomer;
            $('#modal_dict_sys_role').modal('show');
        },
        openProjectRoleModal(mode, id, name, isCustomer, showOwnerAccess, showOtherAccess, editOwnerAccess, editOtherAccess, showOtherDefault, addAccess) {
            this.modalMode = mode;
            this.error = false;
            this.errorMessage = '';
            this.projectRoleEditable.id = id;
            this.projectRoleEditable.name = name;
            this.projectRoleEditable.is_customer = isCustomer;
            this.projectRoleEditable.show_owner_access = showOwnerAccess;
            this.projectRoleEditable.show_other_access = showOtherAccess;
            this.projectRoleEditable.edit_owner_access = editOwnerAccess;
            this.projectRoleEditable.edit_other_access = editOtherAccess;
            this.projectRoleEditable.show_other_default = showOtherDefault;
            this.projectRoleEditable.add_access = addAccess;
            $('#modal_dict_proj_role').modal('show');
        }

    },
    computed: {
        newSystemRoleValid() {
            return this.systemRoleEditable.name !== '';
        },
        newProjectRoleValid() {
            return this.projectRoleEditable.name !== '';
        }
    },
    created() {
        this.getRoles();
    },
    mounted() {

    }
}
</script>
